import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import {
  SESSION_STORAGE_KEYS,
  SESSION_STORAGE_VALUES,
} from '@/constants/session-storage';
import { useFeatureFlag } from '@/hooks/use-feature-flag';
import { GetDisplayPreferences } from '@/modules/user-preferences/queries';
import { mapPageUrlKeyToPath } from '@/utils/page-url-mapper';

/**
 * Component that handles redirecting users to their default landing page
 * after they sign in, if the userPreferences feature flag is enabled.
 */
export function UserPreferencesRedirect() {
  const history = useHistory();
  const featureFlag = useFeatureFlag();
  const { data: displayPreferences } = GetDisplayPreferences.useQuery();

  useEffect(() => {
    const userJustSignedIn =
      sessionStorage.getItem(SESSION_STORAGE_KEYS.USER_JUST_SIGNED_IN) ===
      SESSION_STORAGE_VALUES.USER_JUST_SIGNED_IN;

    if (userJustSignedIn && featureFlag('userPreferences')) {
      if (displayPreferences) {
        sessionStorage.removeItem(SESSION_STORAGE_KEYS.USER_JUST_SIGNED_IN);

        // Redirect to default landing page if defined
        if (displayPreferences.defaultLandingPage) {
          try {
            const redirectPath = mapPageUrlKeyToPath(
              displayPreferences.defaultLandingPage,
            );
            history.replace(redirectPath);
          } catch (error) {
            console.error('Failed to redirect to default landing page:', error);
          }
        }
      }
    }
  }, [history, featureFlag, displayPreferences]);

  return null;
}
